export default function Header({ children }) {
  return <header className="container__header">{children}</header>;
}
